// Lib
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import { NodeViewProps } from '@tiptap/core';

import CalloutNodeViewIcon from './CalloutNodeViewIcon';

const CalloutNodeView: React.FC<NodeViewProps> = (props) => {
    const { node, updateAttributes, extension } = props;
    const { options } = extension;
    const { elementId } = options;

    const popupId = `callout-${elementId}-${node.attrs.key}`;

    return (
        <NodeViewWrapper
            className="CalloutNodeView"
            data-icon={node.attrs.icon}
            data-icon-code={node.attrs.iconCode}
            data-type="callout"
        >
            <CalloutNodeViewIcon node={node} popupId={popupId} updateAttributes={updateAttributes} />
            <NodeViewContent className="callout-content" />
        </NodeViewWrapper>
    );
};

export default CalloutNodeView;
